import { defineMessages } from 'react-intl';

import { NEWS_CATEGORIES } from '@didaskill/domain/news/constants';

export const categoriesMessages = defineMessages<NEWS_CATEGORIES>({
  [NEWS_CATEGORIES.ARTICLES]: {
    defaultMessage: 'Articles',
  },
  [NEWS_CATEGORIES.COACHING]: {
    defaultMessage: 'Coaching',
  },
  [NEWS_CATEGORIES.EXAMS]: {
    defaultMessage: 'Examens',
  },
  [NEWS_CATEGORIES.LESSONS]: {
    defaultMessage: 'Cours',
  },
  [NEWS_CATEGORIES.SCHOOL_LIFE]: {
    defaultMessage: 'Vie scolaire',
  },
  [NEWS_CATEGORIES.DIDASKILL]: {
    defaultMessage: 'Didaskill',
  },
});
